angular.module('appMarketplace')
    .service('OrderService', ['$q', '$http', '$window', 'UrlService', 'CommonService', 'NotificationService',
                             function ($q, $http, $window, UrlService, CommonService, NotificationService) {
        var service = this;

        service.addItemToOrder = function (item, documentId, successCallback, errorCallback) {
            service.addItemsToOrder([item], documentId, successCallback, errorCallback);
        };

        service.addItemsToOrder = function (items, documentId, successCallback, errorCallback) {
            var products = [];
            angular.forEach(items, function iterator(item) {
                products.push({
                    id: item.id,
                    clin: item.clin,
                    quantity: item.quantity,
                    vendorId: item.vendorId,
                    fieldId: item.fieldId
                });
            });

            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/order/' + documentId + '/items'),
                data: products
            };

            $http(req).then(function successCallbackWrapper(response) {
                var basketActionResult = response.data;
                successCallback(basketActionResult);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.getDetails = function (documentId, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/order/' + documentId)
            };

            return $http(req).then(function successCallbackWrapper(response) {
                return successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                return errorCallback(response.data);
            })
        };

        service.getOrderDetails = function (documentId) {
            var promise;
            if (documentId) {
                CommonService.showProgressPanel();
                promise = service.getDetails(documentId,
                    function successCallback(orderDetails) {
                        CommonService.hideProgressPanel();
                        return orderDetails;
                    }, function errorCallback(responseError) {
                        NotificationService.showValidationErrors(responseError);
                        CommonService.hideProgressPanel();
                        return $q.reject();
                    });
            } else {
                var deferred = $q.defer();
                promise = deferred.promise;
                deferred.resolve(false);
            }
            return promise;
        };

        service.goBackToOrder = function (documentId) {
            $window.location.href = UrlService.createAbsoluteUrl('/order/order_redirect.jsp?DocumentId=' + documentId);
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/order-service.js
// module id = 39
// module chunks = 1 4 11 17